module.exports = __webpack_public_path__ + "img/transparent_java.c4342418.png";